import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
import { matchPath } from "react-router-dom";

function hidePadding(url: string): boolean {
  return (
    !!matchPath("/stores/:storeId/redo-concierge/playbook", url) ||
    !!matchPath("/stores/:storeId/redo-concierge/conversations", url) ||
    !!matchPath("/stores/:storeId/redo-concierge/settings", url) ||
    !!matchPath("/stores/:storeId/redo-concierge/analytics", url)
  );
}

export const shopperAgentRoutes: PermissionedRouteObject[] = [
  {
    handle: { breadcrumb: "Concierge" },
    async lazy() {
      const { Page } = await import("../../page");
      return { element: <Page hidePadding={hidePadding} /> };
    },
    children: [
      {
        index: true,
        async lazy() {
          const { ConciergeIndexPage } = await import(
            "../../../concierge/concierge-index-page"
          );
          return { Component: ConciergeIndexPage };
        },
      },
      {
        path: "conversations",
        handle: { breadcrumb: "Conversations" },
        async lazy() {
          const { ConciergeConversationsPage } = await import(
            "../../../concierge/conversations/concierge-conversations-page"
          );
          return {
            Component: () => <ConciergeConversationsPage textConcierge />,
          };
        },
      },
      {
        path: "analytics",
        handle: { breadcrumb: "Analytics" },
        async lazy() {
          const { TextConciergeAnalyticsPage } = await import(
            "@redotech/redo-merchant-marketing-app/text-concierge/analytics/text-concierge-analytics-page"
          );
          return { Component: TextConciergeAnalyticsPage };
        },
      },
      {
        path: "settings",
        handle: { breadcrumb: "Settings" },
        async lazy() {
          const { ConciergeSettingsRoute } = await import(
            "../../../concierge/concierge-settings-route"
          );
          return { Component: ConciergeSettingsRoute };
        },
      },
      {
        path: "playbook",
        handle: { breadcrumb: "Playbook" },
        async lazy() {
          const { ConciergePlaybookRoute } = await import(
            "../../../concierge/concierge-playbook-route"
          );
          return { Component: ConciergePlaybookRoute };
        },
      },
    ],
  },
];
